import * as React from "react";

const columns = (t) => [
    {
        field: "machineType",
        label: t ? t("common.machine_type") : "Typ maszyny",
        sort: "desc",
        width: 53,
        type: "enum",
        enumType: "enums/machineType",
    },
    {
        label: t ? t("object_types.machine_model") : "Model maszyny",
        field: "machineName",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.category") : "Kategoria",
        field: "categoryName",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.comments") : "Uwagi",
        field: "comment",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.installation_number") : "Numer instalacyjny",
        field: "installationNumber",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.contact_with_product") : "Kontakt z produktem",
        field: "contactWithProduct",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.part_name") : "Nazwa części",
        field: "name",
        sort: "desc",
        type: "tooltipImage",
        resolveImage: function (row) {
            return row.files[0];
        },
        width: 53,
    }
];

export default columns;